import { Component, OnInit } from '@angular/core';
import axios from 'axios';

@Component({
  selector: 'app-raindrop',
  templateUrl: './raindrop.component.html',
  styleUrls: ['./raindrop.component.css']
})
export class RaindropComponent implements OnInit {

  constructor() { }
  today: string;
  ngOnInit(): void {
    this.Loaddata();
    var today = new Date();
    this.today = today.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  raintoday: any[] = [];
  Loaddata() {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_rainfall_today")
      .then(res => {
        this.raintoday = res.data.recordset;
      }).catch(err => { console.log(err); })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.raintoday = [];
  }
}
